import React, { ChangeEventHandler, FocusEventHandler, useState } from "react";

import { passwordValidatorLabels } from "./PasswordValidationLabels/labels";
import { useFormData } from "@sp-state/useFormData";
import InputWrapper from "../InputWrapper";
import PasswordValidationLabels from "./PasswordValidationLabels";

import styles from "./PasswordInput.module.scss";

/* LINK
  https://regex101.com/

  Explanation:
  * (?=.*[0-9]) means that the password must contain a single digit from 1 to 9.
  * (?=.*[a-z]) means that the password must contain one lowercase letter.
  * (?=.*[A-Z]) means that the password must contain one uppercase letter.
  * .{8} means that the password must be 8 or more characters long. We must use this at the end of the regex, just before the $ symbol.
*/

const PasswordInput = () => {
  const regex = /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?!.* ).{8,}$/;
  const { password, setError, setValue, setIsValid, setPasswordValidators } =
    useFormData(state => state);

  const [showPassword, setShowPassword] = useState(false);
  const showPasswordOpts = {
    true: {
      icon: "drip-form-eye-slash-icon.svg",
      type: "text",
    },
    false: {
      icon: "drip-form-eye-icon.svg",
      type: "password",
    },
  } as const;
  const showPasswordOpt = showPasswordOpts[`${showPassword}`];

  const onBlur: FocusEventHandler<HTMLInputElement> = e => {
    if (!regex.test(e.target.value)) {
      setError("password", true);
      setIsValid("password", false);
    }
  };

  const onChange: ChangeEventHandler<HTMLInputElement> = e => {
    const { value } = e.target;
    if (password.hasError) setError("password", false);

    setPasswordValidators(value);
    setValue("password", value);
    setIsValid("password", regex.test(value));
  };

  const handleShow = () => {
    setShowPassword(!showPassword);
  };

  return (
    <InputWrapper label="Password">
      <div className={styles.passwordField}>
        <input
          className={`${styles.field} ${password.hasError && styles.error}`}
          onBlur={onBlur}
          onChange={onChange}
          type={showPasswordOpt.type}
          value={password.value}
          name="password"
          autoComplete="new-password"
        />

        <img
          src={`/icons/${showPasswordOpt.icon}`}
          alt="icon"
          className={styles.eyeIcon}
          onClick={handleShow}
        />
      </div>

      <PasswordValidationLabels
        passwordHasError={password.hasError}
        passwordIsValid={password.isValid}
        passwordValidatorLabels={passwordValidatorLabels}
        validPassword={password.validators}
      />
    </InputWrapper>
  );
};

export default PasswordInput;
